<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Fotos da Reunião' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <div>
    <ion-grid *ngIf="!readOnly">
      <ion-row>
        <ion-col size="9">
          <div class="div-top">
            <ion-note slot="start">
              <i class="fa-duotone fa-light fa-image div-icon"></i>
            </ion-note>

            <ion-label class="color-title">
              {{'Fotos da Reunião' | translate}}
            </ion-label>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-list *ngIf="!imageList.length">
      <sem-registro [text]="'Nenhuma Foto encontrada'"></sem-registro>
    </ion-list>

    <div class="gallery">
      <div class="gallery-item" *ngFor="let foto of imageList" (click)="openImg(foto)">
        <img [src]="foto.url | image:''" alt="Foto" />
      </div>
    </div>
  </div>
</ion-content>

<ion-footer class="ion-no-border" *ngIf="loaded && !readOnly">
  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col size="9">
        <div>
          <ion-button class="btn-default btn-foto" expand="block" fill="outline" type="submit" (click)="foto();">
            {{'Adicionar foto' | translate}}
          </ion-button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>